import { getDriverLanguage, normalizeDriverLanguage } from "./driverI18n";

const serviceIssueKeys = [
  "cannot_find_passenger",
  "flight_delay",
  "passenger_late",
  "location_changed",
  "extra_luggage",
  "vehicle_issue",
  "inappropriate_content",
];

const driverChatText = {
  ja: {
    locale: "ja-JP",
    title: "予約チャット",
    preferredLanguage: "表示言語",
    languageOptions: [
      { value: "ja", label: "日本語" },
      { value: "en", label: "English" },
      { value: "zh", label: "简体中文" },
      { value: "zh_tw", label: "繁體中文" },
    ],
    orderSummary: "予約概要",
    service: "サービス",
    serviceTypes: { transfer: "送迎", charter: "貸切" },
    hours: "時間",
    order: "予約番号",
    flight: "便名",
    vehicle: "車両",
    passengers: "人数",
    luggage: "荷物",
    pickup: "お迎え場所",
    dropoff: "目的地",
    passengerLastViewed: "お客様の最終確認",
    driverLastViewed: "ドライバーの最終確認",
    adminLastViewed: "管理者の最終確認",
    notViewed: "未確認",
    system: "システム",
    transferConfirmation: "送迎確認書",
    pinnedImportantInformation: "重要なお知らせ",
    passengerContact: "お客様の連絡先",
    back: "戻る",
    call: "電話",
    quickReply: "クイック返信",
    customTemplates: "マイ定型文",
    noCustomTemplates: "保存した定型文はありません。",
    save: "保存",
    cancel: "キャンセル",
    edit: "編集",
    delete: "削除",
    addCustomTemplate: "定型文を入力",
    addTemplate: "定型文を追加",
    serviceException: "サービス異常",
    serviceExceptions: "報告済みの異常",
    selectServiceException: "異常の内容を選択してください",
    submitServiceException: "異常を送信",
    optionalAdminNote: "管理者への補足（任意）",
    messages: "メッセージ",
    loadingEarlierMessages: "以前のメッセージを読み込み中…",
    noMessages: "メッセージはありません。",
    messageRecalled: "このメッセージは撤回されました。",
    translated: "翻訳",
    chatAttachment: "チャット添付画像",
    openLocation: "位置情報を開く",
    recall: "撤回",
    newMessages: "新しいメッセージ",
    unreadMessages: "ここから未読メッセージ",
    backToLatest: "最新へ",
    typeMessage: "メッセージを入力",
    sending: "送信中…",
    send: "送信",
    attachImage: "画像を添付",
    sendLocation: "現在地を送信",
    invalidImage: "画像ファイルを選択してください。",
    imageTooLarge: "画像は2MB未満にしてください。",
    imageAttachmentMessage: "画像を添付しました",
    locationUnsupported: "この端末では位置情報を共有できません。",
    locationUnavailable: "現在地を取得できませんでした。",
    locationMessage: "現在地",
    confirmRecall: "このメッセージを撤回しますか？",
    confirmDeleteTemplate: "この定型文を削除しますか？",
    roles: { system: "システム", driver: "ドライバー", admin: "管理者", passenger: "お客様" },
    serviceIssues: {
      cannot_find_passenger: "お客様が見つからない",
      flight_delay: "フライト遅延",
      passenger_late: "お客様の遅刻",
      location_changed: "乗降場所の変更",
      extra_luggage: "追加の荷物",
      vehicle_issue: "車両トラブル",
      inappropriate_content: "不適切なメッセージ・迷惑行為",
    },
  },
  en: {
    locale: "en-US",
    title: "Trip Communication Center",
    preferredLanguage: "Display language",
    languageOptions: [
      { value: "en", label: "English" },
      { value: "ja", label: "日本語" },
      { value: "zh", label: "简体中文" },
      { value: "zh_tw", label: "繁體中文" },
    ],
    orderSummary: "Order Summary",
    service: "Service",
    serviceTypes: { transfer: "Transfer", charter: "Charter" },
    hours: "hours",
    order: "Order",
    flight: "Flight",
    vehicle: "Vehicle",
    passengers: "Passengers",
    luggage: "Luggage",
    pickup: "Pick-Up",
    dropoff: "Drop-Off",
    passengerLastViewed: "Passenger last viewed",
    driverLastViewed: "Driver last viewed",
    adminLastViewed: "Admin last viewed",
    notViewed: "Not viewed yet",
    system: "System",
    transferConfirmation: "Transfer Confirmation",
    pinnedImportantInformation: "Pinned Important Information",
    passengerContact: "Passenger Contact",
    back: "Back",
    call: "Call",
    quickReply: "Quick Reply",
    customTemplates: "Custom Templates",
    noCustomTemplates: "No custom templates yet.",
    save: "Save",
    cancel: "Cancel",
    edit: "Edit",
    delete: "Delete",
    addCustomTemplate: "Add a custom template",
    addTemplate: "Add Template",
    serviceException: "Service Exception",
    serviceExceptions: "Service Exceptions",
    selectServiceException: "Select an issue",
    submitServiceException: "Submit issue",
    optionalAdminNote: "Optional note for admin",
    messages: "Messages",
    loadingEarlierMessages: "Loading earlier messages…",
    noMessages: "No messages yet.",
    messageRecalled: "This message was recalled.",
    translated: "Translated",
    chatAttachment: "Chat attachment",
    openLocation: "Open location",
    recall: "Recall",
    newMessages: "New messages",
    unreadMessages: "Unread messages below",
    backToLatest: "Latest",
    typeMessage: "Type your message",
    sending: "Sending…",
    send: "Send",
    attachImage: "Attach image",
    sendLocation: "Send location",
    invalidImage: "Please select an image file.",
    imageTooLarge: "Image must be under 2MB.",
    imageAttachmentMessage: "Image attachment",
    locationUnsupported: "Location sharing is not supported on this device.",
    locationUnavailable: "Unable to get your location.",
    locationMessage: "Location",
    confirmRecall: "Recall this message?",
    confirmDeleteTemplate: "Delete this template?",
    roles: { system: "System", driver: "Driver", admin: "Admin", passenger: "Passenger" },
    serviceIssues: {
      cannot_find_passenger: "Cannot find passenger",
      flight_delay: "Flight delay",
      passenger_late: "Passenger late",
      location_changed: "Location changed",
      extra_luggage: "Extra luggage",
      vehicle_issue: "Vehicle issue",
      inappropriate_content: "Inappropriate message or harassment",
    },
  },
  zh_cn: {
    locale: "zh-CN",
    title: "订单沟通中心",
    preferredLanguage: "显示语言",
    languageOptions: [
      { value: "zh", label: "简体中文" },
      { value: "zh_tw", label: "繁體中文" },
      { value: "ja", label: "日本語" },
      { value: "en", label: "English" },
    ],
    orderSummary: "订单摘要",
    service: "服务类型",
    serviceTypes: { transfer: "接送", charter: "包车" },
    hours: "小时",
    order: "订单号",
    flight: "航班",
    vehicle: "车型",
    passengers: "人数",
    luggage: "行李",
    pickup: "上车地点",
    dropoff: "下车地点",
    passengerLastViewed: "乘客最后查看",
    driverLastViewed: "司机最后查看",
    adminLastViewed: "管理员最后查看",
    notViewed: "尚未查看",
    system: "系统",
    transferConfirmation: "接送确认信息",
    pinnedImportantInformation: "置顶重要信息",
    passengerContact: "乘客联系方式",
    back: "返回",
    call: "拨打电话",
    quickReply: "快捷回复",
    customTemplates: "自定义模板",
    noCustomTemplates: "暂无自定义模板。",
    save: "保存",
    cancel: "取消",
    edit: "编辑",
    delete: "删除",
    addCustomTemplate: "输入自定义模板",
    addTemplate: "添加模板",
    serviceException: "服务异常",
    serviceExceptions: "已报告的服务异常",
    selectServiceException: "请选择异常类型",
    submitServiceException: "提交异常",
    optionalAdminNote: "给管理员的补充说明（可选）",
    messages: "消息",
    loadingEarlierMessages: "正在加载更早消息…",
    noMessages: "暂无消息。",
    messageRecalled: "此消息已撤回。",
    translated: "翻译",
    chatAttachment: "聊天附件",
    openLocation: "打开位置",
    recall: "撤回",
    newMessages: "新消息",
    unreadMessages: "以下为未读消息",
    backToLatest: "回到最新",
    typeMessage: "输入消息",
    sending: "发送中…",
    send: "发送",
    attachImage: "添加图片",
    sendLocation: "发送位置",
    invalidImage: "请选择图片文件。",
    imageTooLarge: "图片必须小于 2MB。",
    imageAttachmentMessage: "图片附件",
    locationUnsupported: "此设备不支持分享位置。",
    locationUnavailable: "无法获取当前位置。",
    locationMessage: "当前位置",
    confirmRecall: "确定撤回这条消息吗？",
    confirmDeleteTemplate: "确定删除这个模板吗？",
    roles: { system: "系统", driver: "司机", admin: "管理员", passenger: "乘客" },
    serviceIssues: {
      cannot_find_passenger: "找不到乘客",
      flight_delay: "航班延误",
      passenger_late: "乘客迟到",
      location_changed: "地点已变更",
      extra_luggage: "行李超出预订",
      vehicle_issue: "车辆异常",
      inappropriate_content: "不当消息或骚扰",
    },
  },
  zh_tw: {
    locale: "zh-TW",
    title: "訂單溝通中心",
    preferredLanguage: "顯示語言",
    languageOptions: [
      { value: "zh_tw", label: "繁體中文" },
      { value: "zh", label: "简体中文" },
      { value: "ja", label: "日本語" },
      { value: "en", label: "English" },
    ],
    orderSummary: "訂單摘要",
    service: "服務類型",
    serviceTypes: { transfer: "接送", charter: "包車" },
    hours: "小時",
    order: "訂單號",
    flight: "航班",
    vehicle: "車型",
    passengers: "人數",
    luggage: "行李",
    pickup: "上車地點",
    dropoff: "下車地點",
    passengerLastViewed: "乘客最後查看",
    driverLastViewed: "司機最後查看",
    adminLastViewed: "管理員最後查看",
    notViewed: "尚未查看",
    system: "系統",
    transferConfirmation: "接送確認資訊",
    pinnedImportantInformation: "置頂重要資訊",
    passengerContact: "乘客聯絡方式",
    back: "返回",
    call: "撥打電話",
    quickReply: "快捷回覆",
    customTemplates: "自訂範本",
    noCustomTemplates: "暫無自訂範本。",
    save: "儲存",
    cancel: "取消",
    edit: "編輯",
    delete: "刪除",
    addCustomTemplate: "輸入自訂範本",
    addTemplate: "新增範本",
    serviceException: "服務異常",
    serviceExceptions: "已回報的服務異常",
    selectServiceException: "請選擇異常類型",
    submitServiceException: "提交異常",
    optionalAdminNote: "給管理員的補充說明（選填）",
    messages: "訊息",
    loadingEarlierMessages: "正在載入更早訊息…",
    noMessages: "暫無訊息。",
    messageRecalled: "此訊息已撤回。",
    translated: "翻譯",
    chatAttachment: "聊天附件",
    openLocation: "開啟位置",
    recall: "撤回",
    newMessages: "新訊息",
    unreadMessages: "以下為未讀訊息",
    backToLatest: "回到最新",
    typeMessage: "輸入訊息",
    sending: "傳送中…",
    send: "傳送",
    attachImage: "新增圖片",
    sendLocation: "傳送位置",
    invalidImage: "請選擇圖片檔案。",
    imageTooLarge: "圖片必須小於 2MB。",
    imageAttachmentMessage: "圖片附件",
    locationUnsupported: "此裝置不支援分享位置。",
    locationUnavailable: "無法取得目前位置。",
    locationMessage: "目前位置",
    confirmRecall: "確定撤回這則訊息嗎？",
    confirmDeleteTemplate: "確定刪除這個範本嗎？",
    roles: { system: "系統", driver: "司機", admin: "管理員", passenger: "乘客" },
    serviceIssues: {
      cannot_find_passenger: "找不到乘客",
      flight_delay: "航班延誤",
      passenger_late: "乘客遲到",
      location_changed: "地點已變更",
      extra_luggage: "行李超出預訂",
      vehicle_issue: "車輛異常",
      inappropriate_content: "不當訊息或騷擾",
    },
  },
};

export function getDriverChatText(language = getDriverLanguage()) {
  const normalized = normalizeDriverLanguage(language);
  return driverChatText[normalized] || driverChatText.zh_cn;
}

export function getDriverChatApiLanguage(language = getDriverLanguage()) {
  const normalized = normalizeDriverLanguage(language);
  if (normalized === "zh_cn") return "zh";
  return normalized;
}

export function validateDriverChatTranslations() {
  const baseKeys = Object.keys(driverChatText.en).sort().join("|");
  Object.entries(driverChatText).forEach(([language, copy]) => {
    if (Object.keys(copy).sort().join("|") !== baseKeys) {
      throw new Error(`driver_chat_translation_keys_mismatch:${language}`);
    }
    const issueKeys = Object.keys(copy.serviceIssues || {}).sort();
    if (issueKeys.join("|") !== [...serviceIssueKeys].sort().join("|")) {
      throw new Error(`driver_chat_service_issue_keys_mismatch:${language}`);
    }
  });
  return true;
}

export { driverChatText };
